export default __webpack_public_path__ + "static/media/PPI-walkway-008.c57c9562.jpg";